import { Icon } from 'components/ui/Icon'
import { Row } from 'components/ui/Row'
import { useLocation, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { ProfileAvatar } from 'components/ProfileAvatar'
import { useMemo } from 'react'

type PageHeaderProps = {
  hasBack?: boolean
}

interface RouteParams {
  [key: string]: string
}

interface RouteMatchResult {
  isMatch: boolean
  params: RouteParams
}

function matchRoute(location: string, routePattern: string): RouteMatchResult {
  // Convert route pattern into regex
  // Replace :paramName with a capture group
  const regexPattern = routePattern.replace(/:[a-zA-Z]+/g, '([^/]+)').replace(/\//g, '\\/')

  const regex = new RegExp(`^${regexPattern}$`)

  // Get parameter names from the route pattern
  const paramNames = (routePattern.match(/:[a-zA-Z]+/g) || []).map((param: string) => param.slice(1))

  // Test if location matches the pattern
  const match = location.match(regex)

  if (!match) {
    return {
      isMatch: false,
      params: {},
    }
  }

  // Extract parameter values from match groups
  const paramValues = match.slice(1)

  // Create params object by combining names and values
  const params = paramNames.reduce<RouteParams>((acc, name, index) => {
    acc[name] = paramValues[index]
    return acc
  }, {})

  return {
    isMatch: true,
    params,
  }
}

export const PageHeader = ({ hasBack }: PageHeaderProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const location = useLocation()

  const onClickGoBack = () => {
    navigate(-1)
  }

  const paths = ['areas/:areaId/blocks/:blockId']

  const showBack = useMemo(() => {
    return paths.some((path) => {
      const pathName = location.pathname.substring(1, location.pathname.length)
      console.debug({ pathName, path })
      const match = matchRoute(pathName, path)
      console.debug({ match })
      return match.isMatch
    })
  }, [location.pathname])

  console.debug({ showBack, location })

  return (
    <Row
      width={'100%'}
      height={'3rem'}
      alignItems={'center'}
      justifyContent={'space-between'}
      className={'tw-p-4 tw-gap-2 tw-border-b-2'}
      style={{
        position: 'sticky',
        top: 0,
      }}
    >
      <Row justifyContent={'flex-start'} className={'tw-gap-2'}>
        {(showBack || hasBack) && (
          <>
            <Icon icon={['fas', 'arrow-left']} onClick={onClickGoBack} className={'tw-cursor-pointer'} />
            <span>{t('goBack')}</span>
          </>
        )}
        <div className={'tw-font-medium'}>Mimir - Your Personal Knowledge Base</div>
      </Row>
      <ProfileAvatar />
    </Row>
  )
}
